export default "__VITE_ASSET__02349c48__"